import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { useCategoryPageFilterKeys } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useCategoryPageFilterKeys";
import { useRequestReferrer } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useRequestReferrer";
import { createCategoryPageFiltersQueryKeys } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/__internal__/useCategoryPageSplitFilterQuery/__internal__/createCategoryPageFiltersQueryKeys";
import { fetchFiltersResults } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/__internal__/useCategoryPageSplitFilterQuery/__internal__/fetchFiltersResults";
import { recordPerformanceMark } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/recordPerformanceMark";
import { useIsCategoryPageFilterSplitEnabled } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useIsCategoryPageFilterSplitEnabled";
import { FILTERS_TIMING_FETCH_END_KEY, FILTERS_TIMING_FETCH_START_KEY } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/consts";
import { useCurrentNavigationPath } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useCurrentNavigationPath";
import { wrapAsyncFn } from "@faire/web--source/common/wrapAsyncFn";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
export var useCategoryPageSplitFilterQuery = function() {
    var filterKeys = useCategoryPageFilterKeys();
    var requestReferrer = useRequestReferrer();
    var navigationPath = useCurrentNavigationPath();
    var isFilterSplitEnabled = useIsCategoryPageFilterSplitEnabled();
    return useQuery({
        queryKey: createCategoryPageFiltersQueryKeys({
            navigationPath: navigationPath,
            filterKeys: filterKeys,
            requestReferrer: requestReferrer
        }),
        queryFn: /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(param) {
                var signal;
                return _ts_generator(this, function(_state) {
                    signal = param.signal;
                    return [
                        2,
                        wrapAsyncFn(function() {
                            return fetchFiltersResults({
                                navigationPath: navigationPath,
                                filterKeys: filterKeys,
                                requestReferrer: requestReferrer
                            }, {
                                signal: signal
                            });
                        }, {
                            before: function() {
                                return recordPerformanceMark(FILTERS_TIMING_FETCH_START_KEY);
                            },
                            after: function() {
                                return recordPerformanceMark(FILTERS_TIMING_FETCH_END_KEY);
                            }
                        })
                    ];
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        enabled: isFilterSplitEnabled,
        staleTime: Infinity,
        placeholderData: keepPreviousData
    });
};
